import axios from 'axios';
import question from './question/index';
import questions from './questions/index';

export default {
  modules: {
    questions,
    question
  },

  namespaced: true,

  state() {
    return {
      token: null,
      item: null,
      loaded: false
    };
  },

  mutations: {
    set_prop(state, data) {
      // key, v
      state[data.key] = data.v;
    },

    set_item(state, v) {
      state.item = v;
    },

    set_token(state, v) {
      state.token = v;
    }
  },
  actions: {
    async load(context) {
      let id = context.state.token;

      return await axios.get(`/1.0/interviews/${id}/tests`).then(r => {
        context.commit('set_item', r.data.data[0]);
      });
    },

    async start(context) {
      let id = context.state.token;
      return await axios.put(`1.0/interviews/${id}/tests/start`).then(r => {
        context.commit('set_prop', {
          key: 'remaining_time',
          v: r.data.data[0].remaining_time
        });
      });
    },

    async end(context) {
      let id = context.state.token;

      return await axios.put(`1.0/interviews/${id}/tests/end`)
    }
  },
  getters: {
    item(state) {
      return state.item;
    },
    token(state) {
      return state.token;
    }
  }
};
